<script lang="ts">
  // libs
  import { onMount } from "svelte";
  import Skeleton from "svelte-skeleton/Skeleton.svelte";

  // components
  import ActionBarCardLink from "@shared/svelte/Components/ActionBarCardLink.svelte";

  // services
  import * as ActionBarDataService from "@shared/services/action_bar_data_service";
  import CloudinaryImageService from "@shared/svelte/Modules/CloudinaryImageService";
  import { EventTracking } from "@shared/services/event_tracking/events";

  // stores
  import { actionBarStore } from "@shared/svelte/Stores/ActionBarStore";
  import LayoutStore from "@shared/svelte/Stores/LayoutStore";

  // data
  let imgSize;

  // constants
  const whatsNewDescriptionDefault = "Check out Provi's latest updates and upcoming features!";
  const whatsNewSrcDefault = window["C"].IMAGE_PATHS["Glasses.svg"];
  const { trackClick } = EventTracking;

  // lifecycle
  onMount(() => {
    (async () => {
      await ActionBarDataService.get();
    })();
  });

  // reactives
  $: isMobile = $LayoutStore.isMobile;
  $: imgSize = isMobile ? 60 : 82;
  $: description = !!$actionBarStore.data.description
    ? $actionBarStore.data.description
    : whatsNewDescriptionDefault;
  $: src = !!$actionBarStore.data.image_upload.cloudinary_image_url
    ? CloudinaryImageService.getUrl(
        $actionBarStore.data.image_upload.cloudinary_image_url,
        imgSize,
        imgSize,
      )
    : whatsNewSrcDefault;
</script>

<ActionBarCardLink
  titleText="New features on Provi"
  icon="Megaphone"
  iconFill="black"
  linkUrl="/sc/whatsnew"
  on:actionClick={() => {
    trackClick("action_bar_see_whats_new_card");
  }}
>
  <div slot="body" class="fizz-text-medium fizz-text-left fizz-text-strong fizz-inset-square-8">
    {#if $actionBarStore.loaded}
      <div class="fizz-flex-row fizz-space-between" class:fizz-stack-24={$LayoutStore.isMobile}>
        <div>{description}</div>
        <div class="fizz-flex-no-shrink" class:fizz-inset-horizontal-16={!isMobile}>
          <img {src} height={imgSize} width={imgSize} alt="whats_new_banner_image" />
        </div>
      </div>
      <div>
        <a
          href="/sc/whatsnew"
          on:click={e => {
            e.stopPropagation();
            trackClick("action_bar_see_whats_new_link");
          }}
          class="fizz-text-strong fizz-text-small">See what's new</a
        >
      </div>
    {:else}
      <Skeleton
        animate={true}
        height={imgSize}
        width={imgSize * 3}
        ariaLabel="whats-new-banner-loading"
      />
    {/if}
  </div>
</ActionBarCardLink>
